import { modals } from "@mantine/modals";
import { Suspense, lazy, useCallback } from "react";
import type { CreateBoardModalVariant } from "./create-board-modal";

const CreateBoardModalView = lazy(() =>
	import("./create-board-modal").then((m) => ({
		default: m.CreateBoardModalView,
	})),
);

export function useCreateBoardModal(
	closeable = true,
	variant: CreateBoardModalVariant = "default",
) {
	const modalId = `create-board-modal-${variant}`;

	const close = useCallback(() => {
		modals.close(modalId);
	}, [modalId]);

	const open = useCallback(() => {
		modals.open({
			modalId,
			centered: true,
			withCloseButton: false,
			closeOnEscape: closeable,
			closeOnClickOutside: closeable,
			zIndex: 2000,
			size: variant === "onboarding" ? "xl" : "lg",
			radius: "md",
			classNames: {
				content: "custom-scrollbar",
			},
			children: (
				<Suspense fallback={null}>
					<CreateBoardModalView
						closeable={closeable}
						onClose={close}
						variant={variant}
					/>
				</Suspense>
			),
		});
	}, [close, closeable, modalId, variant]);

	return { open, close };
}
